import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  type IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import type { EnvironmentProviders } from '@angular/core';
import { environment } from '@szte-griffin/environment';

const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: environment.apiUrlPattern,
  bearerPrefix: 'Bearer',
});

export const provideKeycloakAngular = (): EnvironmentProviders =>
  provideKeycloak({
    config: environment.keycloakConfig,
    initOptions: environment.keycloakConfig.initOptions,
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 15 * 60 * 1000, // 15 minutes
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [apiCondition],
      },
    ],
  });
